import React, { useEffect, useMemo, useState } from 'react';

function labelFromType(type) {
  const map = {
    TAB_SWITCH: 'Tab switch detected',
    FULLSCREEN_EXIT: 'Fullscreen exit detected',
    COPY_ATTEMPT: 'Copy attempt blocked',
    PASTE_ATTEMPT: 'Paste attempt blocked',
    RIGHT_CLICK: 'Right-click blocked',
    KEYBOARD_SHORTCUT: 'Keyboard shortcut blocked',
    WINDOW_BLUR: 'Window focus violation'
  };
  return map[type] || 'Policy violation detected';
}

export default function ViolationWarning({ violationType, count, maxViolations = 3 }) {
  const [visible, setVisible] = useState(Boolean(violationType));

  useEffect(() => {
    if (!violationType) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(t);
  }, [violationType, count]);

  const isLimit = count >= maxViolations;

  const message = useMemo(() => {
    if (!violationType) return '';
    if (isLimit) return 'Assessment auto-submitting due to repeated violations.';
    const remaining = Math.max(0, maxViolations - count);
    return `Warning: ${labelFromType(violationType)}. [${count}/${maxViolations}]${remaining ? ` - ${remaining} more will auto-submit.` : ''}`;
  }, [count, isLimit, maxViolations, violationType]);

  if (!visible || !violationType) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-[1300] px-4 py-3 text-sm text-white ${isLimit ? 'bg-red-600/95' : 'bg-amber-500/95'}`}>
      <div className="mx-auto max-w-6xl">{message}</div>
    </div>
  );
}
